import RssButton from '../../../external/rss-button-widget/rss-button';

export default RssButton;
